import React, { useState } from "react";
import { Tooltip } from "antd";
import { Check, Copy } from "lucide-react";

const CopyButton: React.FC<{ text: string; ariaLabel?: string }> = ({ text, ariaLabel = "Copy" }) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };
    return (
        <Tooltip title={copied ? "Copied!" : "Copy"} placement="bottom" overlayClassName="chat-v2-tooltip-sm">
            <button className="chat-v2-copy-btn" onClick={handleCopy} aria-label={ariaLabel}>
                {copied ? <Check size={14} /> : <Copy size={14} />}
            </button>
        </Tooltip>
    );
};

export default CopyButton;
